import './App.css';
import './Reset.css';
import { UserPage } from "./pages/UserPage";
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import { getSummary, getTopTable, getUserData, getGroupData, show404, setGroup, checkToken, closeReceivedGiftPopup, closeReceivedShopGiftPopup } from "./redux/actions";
import { useParams } from "react-router-dom";
import { Page404 } from "./pages/Page404";
import { PageLoading } from "./pages/PageLoading";
import { LoginPopup } from './components/popups/loginPopup/LoginPopup';
import { ReceivedGiftPopup } from "./components/popups/ReceivedGiftPopup";
import { ConfirmSpinPopup } from './components/popups/confirmSpinPopup/ConfirmSpinPopup';
import { ConfirmGiftPopup } from './components/popups/confirmGiftPopup/ConfirmGiftPopup';

function App(props) {
    let { nickname = null, groupId = null } = useParams();
    const dispatch = useDispatch()
    const loading = useSelector(state => state.app.loading)
    const is404 = useSelector(state => state.app.is404)
    const mainRequest = useSelector(state => state.app.mainRequest)
    const tableRequest = useSelector(state => state.app.tableRequest)
    const summaryRequest = useSelector(state => state.app.summaryRequest)
    const id = useSelector(state => state.user.id)
    const name = useSelector(state => state.user.name)
    const isMobile = useSelector(state => state.app.isMobile)
    const shopStatus = useSelector(state => state.game.gameShop?.settings?.status)
    const receivedGift = useSelector(state => state.game.receivedGift)
    const receivedGiftPopup = useSelector(state => state.game.receivedGiftPopup)
    const receivedShopGift = useSelector(state => state.game.receivedShopGift)
    const receivedShopGiftPopup = useSelector(state => state.game.receivedShopGiftPopup)
    const handleWindowSizeChange = () => {
        if (window.innerWidth < 992 && !isMobile) {
            window.location.reload()
        }
        if (window.innerWidth >= 992 && isMobile) {
            window.location.reload()
        }
    }
    useEffect(() => {
        if(typeof shopStatus === 'string' && shopStatus !== 'archived'){
            const params = (new URL(document.location)).searchParams;
            const tokenUrl = params.get("token");
            if (tokenUrl && id) {
                dispatch(checkToken(id, tokenUrl));
            } else {
                if(name){
                    const token = localStorage.getItem('token_'+name);
                    if (token && id) {
                        dispatch(checkToken(id, token, false));
                    }
                }
            }
        }
    }, [localStorage.getItem('token_'+name), id, name, shopStatus, dispatch])
    useEffect(() => {
        const group = props.group ? true : false;
        dispatch(setGroup(group));
        if (props.group) {
            if (!isNaN(groupId) && Number(groupId) > 0) {
                if (!mainRequest) {
                    dispatch(getGroupData(groupId))
                } else if (parseInt(id) > 0) {
                    if (!summaryRequest) {
                        dispatch(getSummary(id));
                    }
                    if (!loading && !is404 && !tableRequest) {
                        dispatch(getTopTable(id));
                    }
                }
            } else {
                dispatch(show404());
            }
        } else {
            if (typeof (nickname) === 'string' && nickname.length > 0) {
                if (!mainRequest) {
                    dispatch(getUserData(nickname))
                } else if (parseInt(id) > 0) {
                    if (!summaryRequest) {
                        dispatch(getSummary(id));
                    }
                    if (!loading && !is404 && !tableRequest) {
                        dispatch(getTopTable(id));
                    }
                }
            } else {
                dispatch(show404());
            }
        }

    }, [dispatch, nickname, groupId, mainRequest, loading, is404, tableRequest, id, summaryRequest, props.group]);
    useEffect(() => {

        window.addEventListener('resize', handleWindowSizeChange);
        return () => {
            window.removeEventListener('resize', handleWindowSizeChange);
        }
    }, [handleWindowSizeChange]);
    if (loading) {
        return (<PageLoading />)
    }
    if (is404) {
        return (<Page404 />)
    }
    return (
        <div className="App">
            <UserPage />
            <ReceivedGiftPopup gift={receivedGift} popup={receivedGiftPopup} close={closeReceivedGiftPopup}/>
            <ReceivedGiftPopup  gift={receivedShopGift} popup={receivedShopGiftPopup} close={closeReceivedShopGiftPopup}/>
            <LoginPopup />
            <ConfirmSpinPopup />
            <ConfirmGiftPopup/>
        </div>
    );
}

export default App;
